import React from 'react';
import styled from 'styled-components';
import { useAppContext } from '../context/AppContext';
import { Container, hover, text } from '../styles/GlobalStyles';
import { GitHubIcon, LinkedInIcon, MediumIcon } from './common/Icons';

const FooterContainer = styled.footer`
  border-top: 1px solid ${props => props.theme.colors.border};
  padding: 28px 0;
`;

const Inner = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Text = styled.p`
  font-size: ${text.xs};
  color: ${props => props.theme.colors.textTertiary};
`;

const Links = styled.div`
  display: flex;
  gap: 6px;

  a {
    display: grid;
    place-items: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: ${props => props.theme.colors.textTertiary};
    transition: color 150ms ease;

    ${hover} {
      &:hover {
        color: ${props => props.theme.colors.text};
      }
    }
  }
`;

const Footer: React.FC = () => {
  const { content } = useAppContext();
  const { personalInfo } = content;

  return (
    <FooterContainer>
      <Inner>
        <Text>
          © {new Date().getFullYear()} {personalInfo.name}. {content.footer.copyright}
        </Text>
        <Links>
          <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <LinkedInIcon size={16} />
          </a>
          <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <GitHubIcon size={16} />
          </a>
          <a href={personalInfo.medium} target="_blank" rel="noopener noreferrer" aria-label="Medium">
            <MediumIcon size={16} />
          </a>
        </Links>
      </Inner>
    </FooterContainer>
  );
};

export default Footer;
